
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 248 251"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.3 83.3s81.2 40.6 101.5 81.2c40.6-81.2 101.5-142 142-162.3-60.9 101.5-101.5 142-142 243.5C63.1 164.5 2.3 83.3 2.3 83.3z","fill":"#7ac142"}})])
          )
        }
      }
    